module.exports = function () {

    let module = {};

    let results = {};

    // Initial values
    module.values = $('.splash-container').data('values');

    module.initDatepicker = function () {
        require('jquery-ui/ui/keycode');
        require('jquery-ui/ui/widgets/datepicker');

        $('.dob.datepicker').datepicker({
            dateFormat: "d MM yy",
            changeMonth: true,
            changeYear: true,
            minDate: "-90y",
            maxDate: "-18y",
            yearRange: "c-90:c+1"
        });

    };

    module.loadHashSection = function () {
        let url = window.location.href;
        let hash = url.substring(url.indexOf("#") + 1);

        if (url.includes('#') && hash) {
            console.log('Hash #' + hash + ' detected. Loading section requested.');
            module.loadSection(hash);
        }
    };

    module.loadSection = function (id) {

        let section = $('.splash-container section#' + id);
        let steps = $('.splash-container section').length;

        console.log('Loading section ' + section.data('id') + '/' + steps)


        $('.splash-container section').removeClass('active');
        section.addClass('active');

        // Remove click bindings
        $('.steps-container .btn')
            .off('click', module.nextPrevSection)
            .off('click', module.finish);


        $('.steps-nav .step').removeClass('active');
        $('.steps-nav .step-' + section.data('id')).addClass('active');


        if (section.data('id') == 1) {
            $('.steps-container .btn.previous').addClass('disabled').off('click', module.nextPrevSection);
            $('.steps-container .btn.next').on('click', module.nextPrevSection);

        } else if (section.data('id') == steps) {
            $('.steps-container .btn.previous').on('click', module.nextPrevSection);

            $('.steps-container .btn.next')
                .html('Submit')
                .addClass('submit')
                .on('click', module.finish);

        } else {
            // Disable/enable back/prev buttons
            $('.steps-container .btn.previous').on('click', module.nextPrevSection).removeClass('disabled');

            $('.steps-container .btn.next').html('Next Step')
                .on('click', module.nextPrevSection);
        }

    };


    module.checkValid = function () {

        let validationModules = [
            'module.applicationFormValidator',
        ];

        let invalids = 0;

        $.each(validationModules, function (i, validationModuleName) {

            let vm = eval(validationModuleName);

            if (vm) {
                vm.form();
                console.log(vm);
                if (vm.numberOfInvalids()) {
                    console.log('Form validation invalid - ' + vm.numberOfInvalids() + ' errors')
                    vm.showErrors();

                    // Scroll to first error
                    $('.alert-danger').first().parents('section').first().prop('id', 'first-alert');
                    module.scrollToElement('#first-alert');

                    invalids += vm.numberOfInvalids();

                    return false;
                }
            }
        });

        if (!invalids)
            return true;
    };

    module.scrollToElement = function (element) {
        console.log('Attempt to scroll to el ' + element);
        $('html,body').animate({scrollTop: $(element).offset().top}, 'slow', function () {
            if ($(element).length && $(element).next().hasClass('collapse')) {
                $(element).next().collapse('show');
            }
        });
    };


    module.initFormValidation = function () {
        require('jquery-validation');

        if ($('#application-form').length)
            module.applicationFormValidator = $('#application-form').validate({ // initialize the plugin
                errorClass: 'alert alert-danger',
                rules: {

                    first_name: {
                        required: true,
                        minlength: 2
                    },
                    last_name: {
                        required: true,
                        minlength: 2
                    },

                    email: {
                        required: true,
                        email: true
                    },
                    phone: {
                        required: true,
                    },
                    mobile: {
                        required: true,
                    },
                    age: {
                        required: true,
                    },
                    occupation: {
                        required: true,
                    },
                    employers_name: {
                        required: true,
                    },
                    expected_mileage: {
                        required: true,
                    },
                    hire_reason: {
                        required: true,
                    },
                    area_of_use: {
                        required: true,
                    },
                    ni_number: {
                        required: true,
                    },
                    date_of_birth: {
                        required: true,
                    },
                    gender: {
                        required: true,
                    },
                    ethnicity: {
                        required: true,
                    },
                    disabilities: {
                        required: true,
                    },
                }


            });


    };


    module.detectInputChange = function () {

        $('.form-control,.form-check-input,.bootstrap-toggle').change(function () {

            $.each($('#hgv-application').serializeControls(), function (index, value) {
                module.values[index] = value;
            });

            module.setValues();

        });

        // Toggles
        if ($(this).attr('type') == 'checkbox') {

            let toggleOn = false;
            //Check
            $("#driving-history input[type='checkbox']").each(function () {
                if ($(this).prop('checked'))
                    toggleOn = true;
            });

            toggleOn ? $('#history-details').fadeIn(500) : $('#history-details').fadeOut(500);

        }


    }

    module.finish = function () {

        if (module.checkValid() === true) {
            $('body').addClass('loading');
            $('form#application-form').submit();

        }
    };

    module.formSetup = function () {

        $('.steps-container .btn.next,.submit')
            .addClass('submit')
            .on('click', module.nextPrevSection);


        $('.form-floating.has-desc select').change(function () {

            $(this).parents('.form-floating')
                .next('.desc-container').addClass('d-none');

            if ($(this).val() == 'Yes')
                $(this).parents('.form-floating')
                    .next('.desc-container').removeClass('d-none');
        });
    }


    module.runNextPrev = function (btn) {
        $('body').addClass('loading');

        setTimeout(function () {

            let thisSection = $('.splash-container section.active');
            let prevSection = thisSection.prev('section');
            let nextSection = thisSection.next('section');
            let newSection;

            // Set new section
            if (btn.hasClass('previous')) {
                newSection = prevSection;
            } else {
                newSection = nextSection;

                if (!newSection.length) {
                    newSection = thisSection;
                }
            }

            module.loadSection(newSection.attr('id'));

            window.scrollTo(0, 0);

            $('body').removeClass('loading');

        }, 500);
    }

    module.nextPrevSection = function () {

        let btn = $(this);

        if (btn.hasClass('next')) {
            if (module.checkValid())
                module.runNextPrev(btn);
        } else
            module.runNextPrev(btn);
    };


    module.initSteps = function () {
        $('.steps-container .btn').click(module.nextPrevSection);
    };


    module.setResults = function () {

        $('.result').removeClass('animated pulse');
        $('.result').addClass('animated pulse');
    };


    module.getValues = function () {

        $.ajax({
            type: "GET",
            url: "/getValues",
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            success: function (data) {
                //module.values = $.parseJSON(data);
                module.values = data;

                //module.initTableStyles();

            },
        });

    };

    module.setValues = function () {

        $.ajax({
            type: "POST",
            url: "/postValues",
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: {values: $('form').serializeControls()},
            success: function () {
                //module.initTableStyles();
                console.log('Values stored in session');
            },

        });

    };

    module.initUploadFiles = function () {

        $('.custom-file-input').change(function () {
            module.uploadFile(this.files[0], $(this));
        });

        $('.uploaded-file .delete').click(function () {
            module.deleteFile($(this));
        });

    };

    module.uploadFile = function (file, el) {
        let form = document.forms.namedItem("upload_documents"); // high importance!, here you need change "yourformname" with the name of your form
        let formdata = new FormData(form); // high importance!
        let name = el.attr('name');
        let fileInput = $("input[name='" + name + "']");
        let fileContainer = fileInput.parent();
        let uploadInput = fileContainer.html();

        formdata.append('name', name);
        fileContainer.html('Uploading...');

        $('body').addClass('loading');

        $.ajax({
            async: true,
            type: "POST",
            dataType: "json", // or html if you want...
            contentType: false, // high importance!
            url: '/form/uploads/file',
            data: formdata, // high importance!
            processData: false, // high importance!
            success: function (data) {

                $('body').removeClass('loading');

                if (data.success) {
                    fileContainer.html(data.html)
                } else {
                    fileContainer.css('height', 'auto');

                    fileContainer.append(uploadInput);

                    fileContainer.find('.alert').removeClass('d-none').html(data.message);

                    fileContainer.find('.custom-file-input').change(function () {
                        module.uploadFile(this.files[0], $(this));
                    });
                }
            }
            //timeout: 10000
        });

    };

    module.deleteFile = function (el) {

        let fileContainer = el.parents('.file-upload');

        fileContainer.find('.uploaded-file-container').html('<i class="fa fa-spin fa-spinner fa-2x mt-2"></i>');


        $.ajax({
            async: true,
            type: "POST",
            dataType: "json",
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            url: '/form/uploads/delete',
            data: {
                filename: el.data('filename'),
                path: el.data('path'),
                name: fileContainer.find('.custom-file-input').attr('id'),
            },
            //  processData: false, // high importance!
            success: function (data) {

                if (data.success) {
                    fileContainer.find('.custom-file').removeClass('d-none');
                    fileContainer.find('.custom-file-input').val('');
                    fileContainer.find('.uploaded-file-container').html('');
                } else {

                }
            }
            //timeout: 10000
        });

    }


    return module;

};


$.fn.serializeControls = function () {
    var data = {};

    function buildInputObject(arr, val) {
        if (arr.length < 1)
            return val;
        var objkey = arr[0];
        if (objkey.slice(-1) == "]") {
            objkey = objkey.slice(0, -1);
        }
        var result = {};
        if (arr.length == 1) {
            result[objkey] = val;
        } else {
            arr.shift();
            var nestedVal = buildInputObject(arr, val);
            result[objkey] = nestedVal;
        }
        return result;
    }

    $.each(this.serializeArray(), function () {
        var val = this.value;
        var c = this.name.split("[");
        var a = buildInputObject(c, val);
        $.extend(true, data, a);
    });

    return data;
}

$.fn.isValid = function () {
    return this[0].checkValidity()
}
